import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import 'amcharts3/amcharts/amcharts';
import 'amcharts3/amcharts/serial';
import 'amcharts3/amcharts/themes/light';
// import { AmChartsService } from '@amcharts/amcharts3-angular';

interface ChartData {
  fieldName: string;
  fieldValue: string;
}

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-amcharts',
  templateUrl: './amcharts.component.html',
  styleUrls: ['./amcharts.component.css']
})
export class AmchartsComponent implements OnInit, OnChanges {

  constructor(
    // private AmCharts: AmChartsService
  ) { }

  @Input() valueField: string;
  @Input() titleField: string;
  @Input() theme: string;
  @Input() data: any = [];
  @Input() type;
  @Input() id;
  @Input() title;
  @Input() height;
  @Input() width;
  @Input() category;
  @Input() valueNo;
  @Input() graphData: any = [];
  @Input() xTitle: String;
  @Input() yTitle: String;
  @Input() baloonvalue: String;
  @Input() for: String;
  @Input() from: String;
  @Input() chartTitle: string;
  @Input() isLegendShown: boolean;
  @Input() isExpandedView: boolean;
  hovering: boolean = true;
  clickType: string = 'clickGraphItem';

  public chart: any;
  public colorsArray = ['#e91e63', '#9c27b0', '#3f51b5', '#009688', '#ffeb3b', '#795548', '#607d8b'];

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    switch (this.type) {
      case 'pie': {
        this.showPieDonutChart(changes);
        break;
      }

      // case 'line': {
      //   this.showLineChart(changes);s
      //   break;
      // }

      case 'multiline': {
        this.showMultiLineSerialChart(changes);
        break;
      }

      case 'worldmap': {
        // this.showWorldMap(changes);
        break;
      }
    }

    // if (this.type === 'serial') {
    //   this.showStackedVerticalChart(changes);
    // }
    // else if (this.type === 'piedonut') {
    //   this.showPieDonutChart(changes);
    // }
    // if (this.type === 'comparative-multi-line') {
    //   this.showComparativeMultiLineChart(changes);
    // }
  }

  showPieChart(changes: SimpleChanges): void {
    // let chartConfig = {};

    // // Capitalizes the first first letter of the Chart Titles / Legends
    // const capitalizeFirstLetter = (titleList: ChartData[]): ChartData[] => {
    //   const regExpForLetter = /[a-z]/;

    //   return titleList.map((title) => {
    //     if ( title.fieldName !== null ) {
    //       if ( title.fieldName.charAt(0) && regExpForLetter.test(title.fieldName.charAt(0)) )  {
    //         title.fieldName = `${title.fieldName.charAt(0).toUpperCase()}${title.fieldName.slice(1).toLowerCase()}`;
    //       }
    //     }

    //     return title;
    //   });
    // };

    // if ( changes.data.currentValue && changes.data.currentValue[0].fieldName === 'No Data Found' ) {
    //   chartConfig = {
    //   type: 'pie',
    //   theme: 'light',
    //   startEffect: 'easeInSine',
    //   startDuration: 0,
    //   sequencedAnimation: false,
    //   labelsEnabled: false,
    //   allLabels: [
    //     {
    //       x: '50%',
    //       y: '48%',
    //       text: `${(changes.chartTitle && changes.chartTitle.currentValue) ? changes.chartTitle.currentValue + '\n' : ''}${changes.data.currentValue[0].fieldName}`,
    //       size: 18,
    //       bold: true,
    //       align: 'middle',
    //       color: '#000000'
    //     }
    //   ],
    //   dataProvider: changes.data.currentValue,
    //   valueField: changes.valueField.currentValue,
    //   titleField: changes.titleField.currentValue,
    //   colorField: 'color',
    //   balloonText: '',
    //   labelRadius: 0,
    //   pullOutRadius: 0,
    //   radius: '42%',
    //   innerRadius: '60%',
    //   responsive: {
    //     enabled: true
    //   }
    //   };
    // } else {    // if Data Found
    //   chartConfig = {
    //     type: 'pie',
    //     theme: 'light',
    //     startEffect: 'easeInSine',
    //     startDuration: 1,
    //     sequencedAnimation: true,
    //     labelsEnabled: true,
    //     allLabels: [
    //       {
    //         x: '50%',
    //         y: '48%',
    //         text: (changes.chartTitle && changes.chartTitle.currentValue) ? changes.chartTitle.currentValue : '',
    //         size: 18,
    //         bold: true,
    //         align: 'middle',
    //         color: '#000000'
    //       }
    //     ],
    //     dataProvider: capitalizeFirstLetter(changes.data.currentValue),
    //     valueField: changes.valueField.currentValue,
    //     titleField: changes.titleField.currentValue,
    //     colorField: 'color',
    //     balloonText: `[[title]]<br><span style='font-size:14px'><b>[[fieldValue]]</b> ([[percents]]%)</span>`,
    //     labelRadius: 5,
    //     pullOutRadius: 0,
    //     radius: '42%',
    //     innerRadius: '60%',
    //     responsive: {
    //       enabled: true
    //     },
    //     export: {
    //       enabled: true
    //     }
    //   };
    // }

    // if ( changes.isLegendShown ) {
    //   chartConfig['legend'] = {
    //     useGraphSettings: false,
    //     labelText: `[[title]]`
    //   };
    // }

    // if ( changes.isExpandedView ) {
    //   chartConfig['startAngle'] = -55;
    //   chartConfig['responsive'] = {
    //     enabled: false
    //   };
    // }

    setTimeout(() => {
      var chart = am4core.create(this.id, am4charts.PieChart);
      if (changes.data.currentValue && changes.data.currentValue.length > 0) {
        chart.data = changes.data.currentValue;
        if (chart.data.length) {
          // var count = 0
          // chart.data.forEach(data => {
          //   if (data.Value) {
          //     count = count + data.Value;
          //   }
          //   if (data.Amount) {
          //     count = count + data.Amount;
          //   } if (data.FieldValue) {
          //     count = count + data.FieldValue;
          //   }
          // })
          if (chart.data.length == 0) {
            let label = chart.createChild(am4core.Label);
            label.text = "No Data available";
            label.fontSize = 12;
            label.align = "center";
            label.isMeasured = false;
            label.x = am4core.percent(40);
            label.y = am4core.percent(40);
          }
        }
      } else {
        let label = chart.createChild(am4core.Label);
        label.text = "No Data available";
        label.fontSize = 12;
        label.align = "center";
        label.isMeasured = false;
        label.x = am4core.percent(40);
        label.y = am4core.percent(40);
      }
      var keyArray = [];
      if (changes.data.currentValue && changes.data.currentValue.length) {
        var object = changes.data.currentValue[0]
        for (var i in object) {
          keyArray.push(i);
        }
      }

      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = changes.valueField ? changes.valueField.currentValue : keyArray[1];
      pieSeries.dataFields.category = changes.titleField ? changes.titleField.currentValue : keyArray[0];
      pieSeries.innerRadius = am4core.percent(50);
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;

      var rgm = new am4core.RadialGradientModifier();
      rgm.brightnesses.push(0, 0, 0, 0, 0);
      pieSeries.slices.template.fillModifier = rgm;
      pieSeries.slices.template.strokeModifier = rgm;
      pieSeries.slices.template.strokeOpacity = 0.4;
      pieSeries.slices.template.strokeWidth = 0;
      pieSeries.slices.template.background.fillOpacity = 0.3;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";

      pieSeries.colors.list = [
        am4core.color("#efc948"),
        am4core.color("#4ab19d"),
        am4core.color("#ef4659"),
        am4core.color("#344e5c"),
        am4core.color("#FFC75F"),
        am4core.color("#F9F871"),
      ];
    }, 100);

    // setTimeout(() => this.AmCharts.makeChart(this.id, chartConfig), Math.trunc(Math.random() * 250));
  }

  showPieDonutChart(changes) {
    setTimeout(() => {
      var chart = am4core.create(this.id, am4charts.PieChart);
      if (changes.data.currentValue && changes.data.currentValue.length > 0) {
        chart.data = changes.data.currentValue;
        if (chart.data.length) {
          // if (changes.chartTitle != null) {
          //   let label = chart.createChild(am4core.Label);
          //   label.text = changes.chartTitle.currentValue;
          //   label.fontSize = 12;
          //   label.align = "center";
          //   label.isMeasured = false;
          //   label.x = am4core.percent(40);
          //   label.y = am4core.percent(40);
          // }
          var count = 0
          // chart.data.forEach(data => {
          //   if (data.Value) {
          //     count = count + data.Value;
          //   }
          //   if (data.Amount) {
          //     count = count + data.Amount;
          //   } if (data.FieldValue) {
          //     count = count + data.FieldValue;
          //   }
          // })
          if (chart.data.length == 0) {
            let label = chart.createChild(am4core.Label);
            label.text = "No Data available";
            label.fontSize = 12;
            label.align = "center";
            label.isMeasured = false;
            label.x = am4core.percent(40);
            label.y = am4core.percent(40);
          }
        }
      } else {
        let label = chart.createChild(am4core.Label);
        label.text = "No Data available";
        label.fontSize = 12;
        label.align = "center";
        label.isMeasured = false;
        label.x = am4core.percent(40);
        label.y = am4core.percent(40);
      }
      var keyArray = [];
      if (changes.data.currentValue && changes.data.currentValue.length) {
        var object = changes.data.currentValue[0]
        for (var i in object) {
          keyArray.push(i);
        }
      }

      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = changes.valueField ? changes.valueField.currentValue : keyArray[1];
      pieSeries.dataFields.category = changes.titleField ? changes.titleField.currentValue : keyArray[0];
      pieSeries.innerRadius = am4core.percent(50);
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;

      var rgm = new am4core.RadialGradientModifier();
      rgm.brightnesses.push(0, 0, 0, 0, 0);
      pieSeries.slices.template.fillModifier = rgm;
      pieSeries.slices.template.strokeModifier = rgm;
      pieSeries.slices.template.strokeOpacity = 0.4;
      pieSeries.slices.template.strokeWidth = 0;
      pieSeries.slices.template.background.fillOpacity = 0.3;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
      chart.legend.scrollable = true;

      // chart.legend = new am4charts.Legend();
      // chart.legend.position = "bottom";

      // chart.legend = new am4charts.Legend();

      // chart.legend.valueLabels.template.align = "left";
      // chart.legend.valueLabels.template.textAlign = "end";

      // chart.legend.labels.template.textDecoration = "none";
      // chart.legend.valueLabels.template.textDecoration = "none";

      // var as = chart.legend.labels.template.states.getKey("active");
      // as.properties.textDecoration = "line-through";
      // as.properties.fill = am4core.color("#000");

      // var as2 = chart.legend.valueLabels.template.states.getKey("active");
      // as2.properties.textDecoration = "line-through";
      // as2.properties.fill = am4core.color("#000");


      // Custom legend
      var legend = new am4charts.Legend();
      legend.parent = chart.chartContainer;
      legend.align = "right";
      legend.position = "right";
      legend.valueLabels.template.text = "{percent}%";
      // legend.data = [{
      //   "name": "Group #1",
      //   "fill": color1,
      //   "percent": Math.round(totals["1"] / total * 100)
      // }, {
      //   "name": "Group #2",
      //   "fill": color2,
      //   "percent": Math.round(totals["2"] / total * 100)
      // }, {
      //   "name": "Group #3",
      //   "fill": color3,
      //   "percent": Math.round(totals["3"] / total * 100)
      // }];

      // pieSeries.colors.list = [
      //   am4core.color("#e91e63"),
      //   am4core.color("#9c27b0"),
      //   am4core.color("#3f51b5"),
      //   am4core.color("#009688"),
      //   am4core.color("#ffeb3b"),
      //   am4core.color("#795548"),
      //   am4core.color("#607d8b")
      // ];
    }, 100);
  }

  showMultiLineChart(changes: SimpleChanges) {
    const graphsArray = [];

    // Capitalizes the first first letter of the Chart Titles / Legends
    const capitalizeFirstLetter = (title: string): string => {
      const regExpForLetter = /[a-z]/;

      if (title && regExpForLetter.test(title)) {
        return `${title.charAt(0).toUpperCase()}${title.slice(1).toLowerCase()}`;
      }

      return title;
    };

    // Returns date strings as date objects
    // const convertDatestringToObject = (dateString: string): Date => {
    //   return new Date(dateString);
    // };

    if (changes != null && changes.data != null && changes.data.currentValue != null && changes.data.currentValue.length > 0) {
      // Capitalizing all chart data titles
      const dataList: any[] = changes.data.currentValue.map((data: any) => {
        const newData = {};

        Object.keys(data).forEach((title: string) => {
          if (title === 'dateString') {
            newData[title] = data[title];
          } else {
            const newTitle = title;
            newData[newTitle] = data[title];
          }
        });

        return newData;
      });

      const object = dataList[0];
      if (object != null) {
        const objectProperties = Object.keys(object);
        if (objectProperties !== null && objectProperties.length > 0) {
          objectProperties.forEach((element, index) => {
            if (element !== 'dateString') {
              const graphInfo = {
                id: `g${index}`,
                balloonText: `[[category]]<br>${element} - <b><span style='font-size:14px;'>[[value]]</span></b>`,
                bullet: 'round',
                bulletSize: 7,
                title: element,
                lineColor: this.colorsArray[index],
                lineThickness: 3,
                negativeLineColor: this.colorsArray[index],
                type: 'smoothedLine',
                valueField: element,
              };

              graphsArray.push(graphInfo);
            }
          });
        }
      }

      // Converting all date strings to Date Objects
      // dataList.forEach((data: any) => {
      //   data.dateString = convertDatestringToObject(data.dateString);
      // });

      const chartConfig = {
        type: 'serial',
        theme: 'light',
        marginTop: 0,
        dataProvider: dataList,
        graphs: graphsArray,
        chartScrollbar: {},
        pathToImages: 'https://cdn.amcharts.com/lib/3/images/',
        categoryField: 'dateString',
        categoryAxis: {
          // dateFormats: [
          //   { period: 'fff', format: 'JJ:NN:SS' },
          //   { period: 'ss', format: 'JJ:NN:SS' },
          //   { period: 'mm', format: 'JJ:NN' },
          //   { period: 'hh', format: 'JJ:NN' },
          //   { period: 'DD', format: 'DD MMM' },
          //   { period: 'WW', format: 'DD MMM' },
          //   { period: 'MM', format: 'MM' },
          //   { period: 'YYYY', format: 'YYYY' }
          // ],
          parseDates: true,
          equalSpacing: true,
          gridPosition: 'start',
          gridAlpha: 0,
          tickPosition: 'start',
          tickLength: 20,
          labelRotation: 0
        },
        legend: {
          useGraphSettings: true,
          labelText: `[[title]]`
        },
        export: {
          enabled: true
        }
      };

      if (changes.isExpandedView) {
        chartConfig['chartCursor'] = {
          categoryBalloonEnabled: true,
          valueLineEnabled: true,
          valueLineBalloonEnabled: true,
          cursorAlpha: 0,
          valueLineAlpha: 0.5,
          fullWidth: true,
          zoomable: false
        };

        chartConfig['chartScrollbar'] = {
          graph: 'g0',
          gridAlpha: 0,
          color: '#888888',
          scrollbarHeight: 55,
          backgroundAlpha: 0,
          selectedBackgroundAlpha: 0.1,
          selectedBackgroundColor: '#888888',
          graphFillAlpha: 0,
          autoGridCount: true,
          selectedGraphFillAlpha: 0,
          graphLineAlpha: 0.2,
          graphLineColor: '#c2c2c2',
          selectedGraphLineColor: '#888888',
          selectedGraphLineAlpha: 1
        };
      }

      // setTimeout(() => this.AmCharts.makeChart(this.id, chartConfig), Math.trunc(Math.random() * 100));
    }
  }

  showMultiLineSerialChart(changes) {
    setTimeout(() => {
      const dataList: any[] = changes.data.currentValue.map((data: any) => {
        const newData = {};

        Object.keys(data).forEach((title: string) => {
          if (title === 'dateString') {
            newData[title] = data[title];
          } else {
            const newTitle = title;
            newData[newTitle] = data[title];
          }
        });

        return newData;
      });

      var chart = am4core.create(this.id, am4charts.XYChart);
      chart.colors.step = 2;

      chart.data = changes.data.currentValue;
      if (chart.data.length == 0) {
        let label = chart.createChild(am4core.Label);
        label.text = "No Data available";
        label.fontSize = 12;
        label.align = "center";
        label.isMeasured = false;
        label.x = am4core.percent(40);
        label.y = am4core.percent(40);
      }
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 50;

      // Create series
      function createAxisAndSeries(field, name, opposite, bullet) {
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        var series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "dateString";
        series.strokeWidth = 2;
        series.fillOpacity = 0.3;
        series.yAxis = valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;

        var interfaceColors = new am4core.InterfaceColorSet();

        var bullet: any;
        switch (bullet) {
          case "triangle":
            bullet = series.bullets.push(new am4charts.Bullet());
            bullet.width = 12;
            bullet.height = 12;
            bullet.horizontalCenter = "middle";
            bullet.verticalCenter = "middle";

            var triangle = bullet.createChild(am4core.Triangle);
            triangle.stroke = interfaceColors.getFor("background");

            triangle.strokeWidth = 2;
            triangle.direction = "top";
            triangle.width = 10;
            triangle.height = 10;
            triangle.fill = "#ef4659"
            break;
          case "rectangle":
            bullet = series.bullets.push(new am4charts.Bullet());
            bullet.width = 10;
            bullet.height = 10;
            bullet.horizontalCenter = "middle";
            bullet.verticalCenter = "middle";

            var rectangle = bullet.createChild(am4core.Rectangle);
            rectangle.stroke = interfaceColors.getFor("background");
            rectangle.strokeWidth = 2;
            rectangle.width = 10;
            rectangle.height = 10;
            rectangle.fill = "#4ab19d"
            break;
          default:
            // bullet = series.bullets.push(new am4charts.CircleBullet());
            // bullet.circle.stroke = interfaceColors.getFor("background");
            // bullet.circle.strokeWidth = 2;
            // bullet.fill = "#efc948"
            break;
        }

        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = opposite;
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.renderer.grid.template.strokeWidth = 0;
      }

      const capitalizeFirstLetter = (title: string): string => {
        const regExpForLetter = /[a-z]/;

        if (title && regExpForLetter.test(title)) {
          return `${title.charAt(0).toUpperCase()}${title.slice(1).toLowerCase()}`;
        }

        return title;
      };

      const object = dataList[0];
      if (object != null) {
        const objectProperties = Object.keys(object);
        if (objectProperties !== null && objectProperties.length > 0) {
          let index = 0;
          objectProperties.forEach((element, index) => {
            if (element !== 'dateString') {
              createAxisAndSeries(element, element, false, '');
              index = index + 1;
              // const graphInfo = {
              //   id: `g${index}`,
              //   balloonText: `[[category]]<br>${element} - <b><span style='font-size:14px;'>[[value]]</span></b>`,
              //   bullet: 'round',
              //   bulletSize: 7,
              //   title: element,
              //   lineColor: this.colorsArray[index],
              //   lineThickness: 3,
              //   negativeLineColor: this.colorsArray[index],
              //   type: 'smoothedLine',
              //   valueField: element,
              // };

              // graphsArray.push(graphInfo);
            }
          });
        }
      }


      // createAxisAndSeries("SMSSent", "SMSSent", false, "circle");
      // createAxisAndSeries("SMSDelivered", "SMSDelivered", true, "triangle");
      // createAxisAndSeries("Failed", "Failed", true, "rectangle");

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();


    }, 100);
  }


  // showLineChart(changes: SimpleChanges) {
  //   const chartConfig = {
  //     type: 'serial',
  //     theme: 'light',
  //     marginTop: 0,
  //     dataProvider: changes.data.currentValue,
  //     graphs: [{
  //       id: 'g1',
  //       balloonText: `[[title]] - <span>₹ [[value]]</span>`,
  //       bullet: 'round',
  //       type: 'smoothedLine',
  //       title: 'Transaction Amount',
  //       bulletSize: 7,
  //       lineColor: '#63cf73',
  //       lineThickness: 3,
  //       negativeLineColor: '#d75a4a',
  //       valueField: 'amount'
  //     }],
  //     chartCursor: {
  //       categoryBalloonEnabled: false,
  //       cursorAlpha: 0,
  //       zoomable: false
  //     },
  //     chartScrollbar: {},
  //     pathToImages: 'https://cdn.amcharts.com/lib/3/images/',
  //     categoryField: 'paymentDate',
  //     categoryAxis: {
  //       gridPosition: 'start',
  //       gridAlpha: 0,
  //       tickPosition: 'start',
  //       equalSpacing: true,
  //       tickLength: 20,
  //       labelRotation: 45
  //     },
  //     legend: {
  //       useGraphSettings: true,
  //       labelText: `[[title]]`
  //     },
  //     export: {
  //       enabled: true
  //     }
  //   };

  //   setTimeout(() => this.AmCharts.makeChart(this.id, chartConfig), 100);
  // }

  // showComparativeMultiLineChart(changes) {
  //   setTimeout(() => {
  //     var chart = this.AmCharts.makeChart(this.id, {
  //       "theme": "light",
  //       "type": "serial",
  //       "dataProvider": changes.data.currentValue,
  //       "valueAxes": [{
  //         "gridAlpha": 0,
  //         "labelsEnabled": false,
  //         "position": "top",
  //         "guides": [{
  //           "value": 0,
  //           "toValue": 100,
  //           "lineAlpha": 1,
  //           "label": "Gradeable"
  //         }, {
  //           "value": 100,
  //           "toValue": 200,
  //           "lineAlpha": 1,
  //           "label": "Non Gradeable"
  //         }, {
  //           "value": 200,
  //           "toValue": 300,
  //           "lineAlpha": 1,
  //           "label": "DR Noted"
  //         }, {
  //           "value": 300,
  //           "toValue": 400,
  //           "lineAlpha": 1,
  //           "label": "DME Noted"
  //         }, {
  //           "value": 400,
  //           "toValue": 500,
  //           "lineAlpha": 1,
  //           "label": "AI vs Expert Match"
  //         },
  //         {
  //           "value": 500,
  //           "toValue": 600,
  //           "lineAlpha": 1,
  //           "label": "Autonomous Report"
  //         }]
  //       }],
  //       "startDuration": 1,
  //       "graphs": [{
  //         "fillColors": "#5b9bd5",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val1start",
  //         "valueField": "val1end",
  //         "labelText": "[[val1label]]%"
  //       }, {
  //         "fillColors": "#ed7d31",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val2start",
  //         "valueField": "val2end",
  //         "labelText": "[[val2label]]%"
  //       }, {
  //         "fillColors": "#a5a5a5",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val3start",
  //         "valueField": "val3end",
  //         "labelText": "[[val3label]]%"
  //       }, {
  //         "fillColors": "#ffbf00",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val4start",
  //         "valueField": "val4end",
  //         "labelText": "[[val4label]]%"
  //       }, {
  //         "fillColors": "#4472c4",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val5start",
  //         "valueField": "val5end",
  //         "labelText": "[[val5label]]%"
  //       }, {
  //         "fillColors": "#489688",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0,
  //         "type": "column",
  //         "clustered": false,
  //         "openField": "val6start",
  //         "valueField": "val6end",
  //         "labelText": "[[val6label]]%"
  //       }],
  //       "rotate": true,
  //       "categoryField": "category",
  //       "categoryAxis": {
  //         "gridPosition": "start",
  //         "axisAlpha": 0,
  //         "gridAlpha": 0.1,
  //         "position": "left"
  //       },
  //       "responsive": {
  //         "enabled": true
  //       }
  //     });
  //   }, 100)
  // }

  // showWorldMap(changes: SimpleChanges) {
  //   setTimeout(() => {
  //     const map = this.AmCharts.makeChart(this.id, {
  //       /**
  //        * this tells amCharts it's a map
  //        */
  //       type: 'map',

  //       /**
  //        * create data provider object
  //        * map property is usually the same as the name of the map file.
  //        * getAreasFromMap indicates that amMap should read all the areas available
  //        * in the map data and treat them as they are included in your data provider.
  //        * in case you don't set it to true, all the areas except listed in data
  //        * provider will be treated as unlisted.
  //        */
  //       dataProvider: {
  //         map: 'worldLow',
  //         areas: [
  //           { 'id': 'IN', 'color': '#61c2e6', 'balloonText': 'Accounts : 10 <br/> Screening Center : 134' },
  //           { 'id': 'UG', 'color': '#61c2e6', 'balloonText': 'Accounts : 1 <br/> Screening Center : 5' },
  //           { 'id': 'SG', 'color': '#61c2e6', 'balloonText': 'Accounts : 4 <br/> Screening Center : 12' }
  //         ]
  //       },

  //       /**
  //        * create areas settings
  //        * autoZoom set to true means that the map will zoom-in when clicked on the area
  //        * selectedColor indicates color of the clicked area.
  //        */
  //       areasSettings: {
  //         autoZoom: true,
  //         selectedColor: '#CC0000'
  //       },

  //       /**
  //        * let's say we want a small map to be displayed, so let's create it
  //        */
  //       // "smallMap": {}
  //     });
  //   }, 100);
  // }

  // showPieDonutChart(changes) {
  //   var theme = "light";
  //   if (changes.theme != null) {
  //     theme = changes.theme.currentValue;
  //   }
  //   setTimeout(() => {
  //     var chart = this.AmCharts.makeChart(this.id, {
  //       "type": "pie",
  //       "theme": theme,
  //       "dataProvider": changes.data.currentValue,
  //       "valueField": changes.valueField.currentValue,
  //       "titleField": changes.titleField.currentValue,
  //       "labelRadius": 5,

  //       "radius": "42%",
  //       "innerRadius": "60%",
  //       "labelText": "[[title]]",
  //       "export": {
  //         "enabled": true
  //       }
  //     });

  //     if (changes.data.currentValue == null || changes.data.currentValue.length === 0) {
  //       chart.addLabel("50%", "50%", "No record available", "middle", 15, "#f4516c");
  //     }
  //   }, 100);
  // }


  // showStackedVerticalChart(changes) {
  //   setTimeout(() => {
  //     var chart = this.AmCharts.makeChart(this.id, {
  //       "type": this.type,
  //       "theme": "light",
  //       "depth3D": 20,
  //       "angle": 30,
  //       "legend": {
  //         "horizontalGap": 10,
  //         "useGraphSettings": true,
  //         "markerSize": 10
  //       },
  //       "dataProvider": changes.data.currentValue,
  //       "valueAxes": [{
  //         "gridColor": "#FFFFFF",
  //         "gridAlpha": 0.2,
  //         "dashLength": 0
  //       }],
  //       "gridAboveGraphs": true,
  //       "startDuration": 1,
  //       "graphs": [{
  //         "balloonText": "[[category]]: <b>[[value]]</b>",
  //         "fillAlphas": 0.8,
  //         "lineAlpha": 0.2,
  //         "type": "column",
  //         "valueField": "visits"
  //       }],
  //       "chartCursor": {
  //         "categoryBalloonEnabled": false,
  //         "cursorAlpha": 0,
  //         "zoomable": false
  //       },
  //       "categoryField": "country",
  //       "categoryAxis": {
  //         "gridPosition": "start",
  //         "gridAlpha": 0,
  //         "tickPosition": "start",
  //         "tickLength": 20
  //       },
  //       "export": {
  //         "enabled": true
  //       }
  //     });
  //     if (this.data == null || this.data.length === 0) {
  //       // this.title.addLabel("50%", "50%", "No record available", "middle", 15, "#f4516c");
  //     }
  //   }, 300);
  // }
}
